import { render, staticRenderFns } from "./td-customerApprove.vue?vue&type=template&id=6ed35a02&"
import script from "./td-customerApprove.vue?vue&type=script&lang=js&"
export * from "./td-customerApprove.vue?vue&type=script&lang=js&"
import style0 from "./td-customerApprove.vue?vue&type=style&index=0&id=6ed35a02&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports